// ============================================
// INFRASTRUCTURE - Storefront Repository (público, sin JWT)
// ============================================

import { axiosClient } from './axios-client';

export interface StorefrontProducto {
  productoAlmacenId: number;
  nombre: string;
  categoria: string | null;
  precioVenta: number;
  venderPor: 'U' | 'F';
  stock: number | null;
  imagenUrl: string | null;
}

export interface StorefrontData {
  almacenId: number;
  nombre: string;
  logoUrl: string | null;
  colorFondo: string | null;
  productos: StorefrontProducto[];
}

export interface CrearPedidoPublicoPayload {
  nombreCliente: string;
  telefonoCliente: string;
  fechaHoraPickup: string; // ISO 8601
  items: { productoAlmacenId: number; cantidad: number }[];
}

export interface CrearPedidoPublicoResult {
  pedidoId: number;
}

export const storefrontRepository = {
  async obtenerStorefront(almacenId: number): Promise<StorefrontData> {
    const { data } = await axiosClient.get<StorefrontData>(
      `/public/store/${almacenId}/productos`
    );
    return data;
  },

  async crearPedido(
    almacenId: number,
    payload: CrearPedidoPublicoPayload
  ): Promise<CrearPedidoPublicoResult> {
    console.log('crearPedido payload', payload);
    const { data } = await axiosClient.post<CrearPedidoPublicoResult>(
      `/public/store/${almacenId}/pedidos`,
      payload
    );
    return data;
  },
};
